export function setCookie(name, value, days = 30) {
  const expires = new Date(Date.now() + days * 864e5)  // 864e5 ms = 1 day
    .toUTCString();
  document.cookie = [
    `${name}=${encodeURIComponent(value)}`,
    `expires=${expires}`,
    `path=/`,
  ].join('; ');
}

export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}

export function getCookie(name) {
  const pattern = new RegExp(
    `(?:^|;\\s*)${name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1')}=([^;]*)`
  );
  const match = document.cookie.match(pattern);
  return match ? decodeURIComponent(match[1]) : null;
}